'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  accentColor: null,
  textColor: null,
  useDefaultColor: false
}, 'ColoringRecord');
module.exports = exports['default'];